import { render, staticRenderFns } from "./PopularProjects.vue?vue&type=template&id=0b56a45c&scoped=true"
import script from "./PopularProjects.vue?vue&type=script&lang=js"
export * from "./PopularProjects.vue?vue&type=script&lang=js"
import style0 from "./PopularProjects.vue?vue&type=style&index=0&id=0b56a45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b56a45c",
  null
  
)

export default component.exports